<template>
  「お客様本位の接客」をモットーとし、明確な指針として<NuxtLink
    href="/lp/fiduciaryduty"
    >フィデューシャリーデューティー宣言</NuxtLink
  >を公表しています。またオカネコのオンラインアドバイザー（当社社員）については、金融商品の成約に応じたインセンティブ制度はなし・分業体制を採用しています。
</template>
